import { ParameterConfigString } from 'app/model/pipeline/parameter-config-string';
import { IViolation } from 'app/model/base/annotation';
import { ValueAdapter } from '../value.adapter';
import { Owned } from 'app/model/base/named';
import { ParameterConfigStringUtils } from 'shell-models-lib';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toParameterObject(pArray: ParameterConfigString[] | undefined, hasType: boolean = false): any {
    if (pArray != null && pArray.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result: any = {};
        pArray.forEach((v) => {
            if (hasType) {
                result[v.name] = {
                    value: ValueAdapter.toResource(v, ParameterConfigString.VALUE),
                    type: v.type
                };
            } else {
                result[v.name] = ValueAdapter.toResource(v, ParameterConfigString.VALUE);
            }
        });
        return result;
    } else {
        return undefined;
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toParameterClass(pObject: any, owner: Owned, hasType: boolean = false): ParameterConfigString[] | undefined {
    if (pObject != null) {
        const result: ParameterConfigString[] = [];
        for (const propertyName in pObject) {
            const paramConfig = Owned.create<ParameterConfigString>(ParameterConfigString.MODEL, owner);
            paramConfig.name = propertyName;

            if (hasType) {
                paramConfig.type = pObject[propertyName].type;
                ValueAdapter.toModel(paramConfig, ParameterConfigString.VALUE, pObject[propertyName].value);
            } else {
                ValueAdapter.toModel(paramConfig, ParameterConfigString.VALUE, pObject[propertyName]);
            }

            result.push(paramConfig);
        }
        return result;
    } else {
        return [];
    }
}

export function createParameterConfigurationValidator(allowNull: boolean = false): (_activity?: {}, configs?: ParameterConfigString[], violation?: IViolation) => IViolation[] | undefined {
    return ParameterConfigStringUtils.createParameterConfigurationValidator(allowNull);
}
